import { render } from "./record.vue?vue&type=template&id=fdcb33ba&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=fdcb33ba&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdcb33ba"]])

export default __exports__